import { truncate } from "lodash"

export const columns = (isLeadership) => {
  let showLeaderCol = false

  if (isLeadership === 2) {
    showLeaderCol = true
  }

  return [
    {
      title: "Nombre",
      dataIndex: "employee_name",
      sorter: (a, b) => a.employee_name.localeCompare(b.employee_name),
      width: 190,
      key: "employee_name",
      render: (text) => truncate(text, { length: showLeaderCol ? 20 : 24 }),
    },
    {
      title: "Puesto",
      dataIndex: "positions_name",
      key: "positions_name",
      width: 160,
      render: (text) => truncate(text, { length: 18 }),
    },
    {
      title: "División",
      dataIndex: "division_name",
      key: "division_name",
      width: 190,
      render: (text) => truncate(text, { length: 24 }),
    },
    {
      title: "Líder",
      dataIndex: "employee_boss",
      className: showLeaderCol ? "" : "hide-leader-column",
      key: "employee_boss",
      width: 190,
      render: (text) => truncate(text, { length: 14 }),
    },
  ]
}
